import React, { createContext, useContext, useState, useEffect } from "react";

//Firebase
import { firestore } from "../config/config";

//Context
import { AuthContext } from "./AuthContext";
import { ExcelContext } from "./ExcelContext";

// Context
export const ClientContext = createContext();
export const ClientActionContext = createContext();

const ClientContextProvider = (props) => {
  const { user } = useContext(AuthContext);
  const { readExcel, exportToExcel } = useContext(ExcelContext);

  const [clients, setClients] = useState({});
  const [regClients, setRegClients] = useState({});

  //Counter Counts
  const [clientsCount, setClientsCount] = useState(0);
  const [taskCount, setTaskCount] = useState(0);
  const [taskDoneCount, setTaskDoneCount] = useState(0);

  //Clients Registration
  const registerClient = (
    name,
    phoneNo,
    agentID,
    setAlertTitle,
    setErr,
    setSuccess,
  ) => {
    firestore
      .collection("clients")
      .where("phoneNo", "==", phoneNo)
      .where("agencyID", "==", user.uid)
      .get()
      .then((doc) => {
        if (!doc.empty) {
          popUp(
            setAlertTitle,
            "Client Already Exists!",
            setErr,
            `The client containing ${phoneNo} phone number already exist in database!`,
          );
        } else {
          // Add document
          firestore
            .collection("clients")
            .add({
              name: name,
              phoneNo: phoneNo,
              agentID: agentID,
              agencyID: user.uid,
            })
            .then((doc) => {
              firestore
                .collection("tasklist")
                .add({
                  agentID: agentID,
                  agencyID: user.uid,
                  clientID: doc.id,
                  clientName: name,
                  clientNo: phoneNo,
                  feedID: "",
                  feedStatus: false,
                  recStatus: false,
                  recURL: "",
                })
                .then(() => {
                  popUp(
                    setAlertTitle,
                    "Client Inserted!",
                    setSuccess,
                    `Name: ${name}, Phone Number: ${phoneNo} added as Client in your agency successfully. Also assigned to your Agent.`,
                  );
                });
            });
        }
      });
  };

  //Clients Registration
  const reassignClient = (
    name,
    phoneNo,
    clientID,
    agentID,
    setAlertTitle,
    setErr,
    setSuccess,
  ) => {
    firestore
      .collection("tasklist")
      .where("clientID", "==", clientID)
      .where("agencyID", "==", user.uid)
      .where("agentID", "==", agentID)
      .get()
      .then((doc) => {
        if (!doc.empty) {
          popUp(
            setAlertTitle,
            "Client Already Assigned!",
            setErr,
            `The client Name: ${name} containing ${phoneNo} phone number already assigned to this agent. & Task havenot done yet!`,
          );
        } else {
          // Add document
          firestore
            .collection("tasklist")
            .add({
              agentID: agentID,
              agencyID: user.uid,
              clientID: clientID,
              clientName: name,
              clientNo: phoneNo,
              feedID: "",
              feedStatus: false,
              recStatus: false,
              recURL: "",
            })
            .then(() => {
              popUp(
                setAlertTitle,
                "Client Ressigned!",
                setSuccess,
                `Name: ${name}, Phone Number: ${phoneNo} reassigned as task in your selected agent successfully.`,
              );
            });
        }
      });
  };

  const updateClient = (
    name,
    phoneNo,
    clientID,
    agentID,
    setAlertTitle,
    setErr,
    setSuccess,
  ) => {
    firestore
      .collection("clients")
      .doc(clientID)
      .update({
        agentID: agentID,
      })
      .then(() => {
        firestore
          .collection("tasklist")
          .where("clientID", "==", clientID)
          .where("agencyID", "==", user.uid)
          .where("agentID", "==", agentID)
          .get()
          .then((doc) => {
            if (!doc.empty) {
              popUp(
                setAlertTitle,
                "Client Already Assigned!",
                setErr,
                `The client Name: ${name} containing ${phoneNo} phone number already assigned to this agent. & Task havenot done yet!`,
              );
            } else {
              // Add document
              firestore
                .collection("tasklist")
                .add({
                  agentID: agentID,
                  agencyID: user.uid,
                  clientID: clientID,
                  clientName: name,
                  clientNo: phoneNo,
                  feedID: "",
                  feedStatus: false,
                  recStatus: false,
                  recURL: "",
                })
                .then(() => {
                  popUp(
                    setAlertTitle,
                    "Client Updated!",
                    setSuccess,
                    `Name: ${name}, Phone Number: ${phoneNo} Updated as task in your selected agent successfully.`,
                  );
                });
            }
          });
      });
  };

  //Alert Popup
  const popUp = (setTitle, title, setMsg, msg) => {
    setTitle(title);
    setMsg(msg);
    setTimeout(() => {
      setTitle("");
      setMsg("");
    }, 10000);
  };

  //Handle Excel
  const uploadedExcel = (obj) => {
    const sortedObj = [];

    obj.map((data) => {
      return firestore
        .collection("clients")
        .where("phoneNo", "==", data.phoneNo)
        .get()
        .then((doc) => {
          if (doc.empty) {
            sortedObj.push(data);
          }
        });
    });

    setClients(sortedObj);
  };

  const fileHeader = ["name", "phoneNo"];
  const readFile = (file, Alert) => {
    readExcel(file, uploadedExcel, Alert, fileHeader);
  };

  const demoClientFile = () => {
    exportToExcel([fileHeader], "Demo Clients File");
  };

  useEffect(() => {
    //--> Working
    if (user.uid !== undefined) {
      firestore
        .collection("clients")
        .where("agencyID", "==", user.uid)
        .onSnapshot((docSnap) => {
          setRegClients(
            docSnap.docs.map((Client) => {
              return {
                name: Client.data().name,
                phoneNo: Client.data().phoneNo,
                agentID: Client.data().agentID,
                clientID: Client.id,
              };
            }),
          );

          setClientsCount(0);
          docSnap.docs.map(() => {
            return setClientsCount((prev) => prev + 1);
          });
        });
      firestore
        .collection("tasklist")
        .where("agencyID", "==", user.uid)
        .onSnapshot((doc) => {
          setTaskCount(0);
          doc.docs.map(() => {
            return setTaskCount((prev) => prev + 1);
          });
        });
      firestore
        .collection("completeTask")
        .where("agencyID", "==", user.uid)
        .onSnapshot((doc) => {
          setTaskDoneCount(0);
          doc.docs.map(() => {
            return setTaskDoneCount((prev) => prev + 1);
          });
        });
    }
  }, [user.uid]);

  const clientDetail = (id, state) => {
    if (id) {
      firestore
        .collection("clients")
        .doc(id)
        .onSnapshot((doc) =>
          state({ name: doc.data().name, phoneNo: doc.data().phoneNo }),
        );
    }
  };

  const removeClient = (phoneNo) => {
    setClients(clients.filter((data) => data.phoneNo !== phoneNo));
  };

  return (
    <ClientContext.Provider
      value={{ clients, regClients, clientsCount, taskCount, taskDoneCount }}
    >
      <ClientActionContext.Provider
        value={{
          registerClient,
          reassignClient,
          updateClient,
          readFile,
          demoClientFile,
          clientDetail,
          removeClient,
        }}
      >
        {props.children}
      </ClientActionContext.Provider>
    </ClientContext.Provider>
  );
};

export default ClientContextProvider;
